import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }
  
 
  public getVendorTasks(vendorCompanyId:number): Observable<any> {
    return this.apiService.get(`Tasks/vendortasks/${vendorCompanyId}`);
  }

  
  
}